import * as React from 'react';

import { AnalyticsStore } from 'bernie-core';
import { LocalizedComponentProps, withLocalization } from 'bernie-l10n';
import { UitkMediaGalleryImageView } from 'uitk-react-media-gallery';
import { QueuedImage } from './queued-image';

interface MediaGalleryImageModel {
  caption: string;
  src: string;
  alt?: string;
  thumbnailSrc?: string;
  fallBackImage?: string;
  element?: object;
}

interface MediaGalleryProps {
  analytics?: AnalyticsStore;
  currentIndex?: number;
  galleryName?: string;
  images: MediaGalleryImageModel[];
  onIndexChange?: (index: number) => void;
}

type LocalizedMediaGalleryProps = LocalizedComponentProps & MediaGalleryProps;

@withLocalization
export class MediaGallery extends React.Component<LocalizedMediaGalleryProps> {
  constructor(props) {
    super(props);
  }

  private getQueuedImages(index: number, images: MediaGalleryImageModel[]) {
    const queuedImages = images.slice(0);

    if (queuedImages && queuedImages.length > 0) {
      if (index - 1 >= 0) {
        queuedImages[index - 1] = { ...queuedImages[index - 1] };
        queuedImages[index - 1].element = (
          <QueuedImage
            key={`prev1_${queuedImages[index - 1].src}`}
            src={queuedImages[index - 1].src}
            alt={queuedImages[index - 1].caption}
          />
        );
      }

      if (index + 1 <= queuedImages.length) {
        queuedImages[index + 1] = { ...queuedImages[index + 1] };
        queuedImages[index + 1].element = (
          <QueuedImage
            key={`next1_${queuedImages[index + 1].src}`}
            src={queuedImages[index + 1].src}
            alt={queuedImages[index + 1].caption}
          />
        );
      }

      if (index + 2 <= queuedImages.length - 1) {
        queuedImages[index + 2] = { ...queuedImages[index + 2] };
        queuedImages[index + 2].element = (
          <QueuedImage
            key={`next2_${queuedImages[index + 2].src}`}
            src={queuedImages[index + 2].src}
            alt={queuedImages[index + 2].caption}
          />
        );
      }
    }

    return queuedImages;
  }

  public render(): JSX.Element {
    const { analytics, currentIndex, galleryName, images, onIndexChange } = this.props;
    const trackingRfrr = `.${galleryName}.PhotoGallery`;
    const mediaGalleryControlsAnalytics = analytics.setupTracker(trackingRfrr, 'Change image in media gallery');
    const queuedImages = this.getQueuedImages(currentIndex, images);

    return (
      <UitkMediaGalleryImageView
        images={queuedImages}
        currentIndex={currentIndex}
        onIndexChange={onIndexChange}
        galleryName={galleryName}
        analytics={mediaGalleryControlsAnalytics}
      />
    );
  }
}
